// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2lZ5H","selected":"Chip_selected__2wB4w"};